import { type MessagingMessage, MessagingStatus } from "@/model/messaging";

export function sortMessages(
  aMessage: MessagingMessage,
  bMessage: MessagingMessage
) {
  const aStatusSort = getStatusSort(aMessage.status);
  const bStatusSort = getStatusSort(bMessage.status);

  if (aStatusSort !== bStatusSort) {
    return aStatusSort - bStatusSort;
  }

  return (
    new Date(aMessage.eventTime ?? "").getTime() -
    new Date(bMessage.eventTime ?? "").getTime()
  );
}

function getStatusSort(status?: MessagingStatus) {
  if (
    status &&
    [
      MessagingStatus.Sending,
      MessagingStatus.Pending,
      MessagingStatus.Typing,
    ].includes(status)
  ) {
    return 0;
  }
  return -1;
}
